import { EuiSideNavItemType, EuiText } from "@elastic/eui";
import { AnketaCatalogs } from "../../";
import { AnketaTranslationOptions } from "src/internationalization/types/context";
import { Hierarchical, Item } from "anketa-core/base";
import { I18nContext } from "anketa-core/i18n";
import { Section } from "anketa-core/index";
import { SideNavProps } from "src/navigation";
import { useEffect, useRef } from "react";

export const SectionTitle = ({ section, i18nContext, shouldFocus }: any) => {
  const textRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (shouldFocus && textRef.current) {
      textRef.current.focus();
    }
  }, [shouldFocus]);

  return (
    <p id={section.id} tabIndex={-1} ref={textRef}>
      {i18nContext.render(section.title)}
    </p>
  );
};

export function getCatalogSideNavItems(
  catalog: Item,
  i18nContext: I18nContext,
  selectItem: ({ route, id, params }: SideNavProps) => void,
  selectedPath?: string
): Array<EuiSideNavItemType<any>> {
  const focusSectionButton = (sectionPath: string) => {
    const el = document.getElementById(`section-button-${sectionPath}`);
    if (el) {
      el.focus();
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  const buildItems = (item: Item): Array<EuiSideNavItemType<any>> => {
    const items: Array<EuiSideNavItemType<any>> = [];

    item.children.forEach((child: Hierarchical) => {
      const section = child as Section;
      if (
        !section.visible ||
        (section.navVisible !== undefined && !section.navVisible)
      ) {
        return;
      }

      const navItem: EuiSideNavItemType<any> = {
        id: section.path,
        name: <p id={section.id}>{i18nContext.render(section.title)}</p>,
        isSelected: section.path === selectedPath,
        onClick: () => {
          focusSectionButton(section.path);
          selectItem({
            params: section.id,
            id: section.path,
          });
        },
        items: buildItems(section),
      };

      items.push(navItem);
    });
    return items;
  };

  return buildItems(catalog);
}

export const sideNavQuestionnaire = (
  questionnairePermission: boolean,
  questionnaires: Array<AnketaCatalogs>,
  baseId: string,
  selectItem: ({ route, id, params }: SideNavProps) => void,
  translate: (key: string, options?: AnketaTranslationOptions) => string,
  focusItem: string,
  currentQuestionnaireItem: EuiSideNavItemType<any>[]
): Array<EuiSideNavItemType<any>> => {
  if (!questionnairePermission) return [];

  const subItems = questionnaires.map((questionnaire, idx) => {
    const rootItem = {
      id: `${questionnaire.id}.${idx + 1}.0`,
      onClick: () => {
        // Set the root Catalog Type
        selectItem({ route: `/` });
      },
      name: `${questionnaire.displayName}`,
      isSelected: focusItem === questionnaire.id,
    };
    const childItems = questionnaire.questionnaire.map((q) => ({
      id: `${q.id}`,
      onClick: () => {
        // Set the root Catalog object
        selectItem({ route: `/${questionnaire.id}/${q.id}`, id: q.id });
      },
      name: `${q.displayName}`,
      isSelected: focusItem === q.id,
      items: focusItem === q.id ? currentQuestionnaireItem : [],
    }));

    return {
      id: `${baseId}.${idx + 1}`,
      name: `${questionnaire.displayName}`,
      items: [rootItem, ...childItems],
    };
  });

  const home = {
    id: `${baseId}.0`,
    name: `${translate("anketa.questionnaires")} - Home `,
    onClick: () => selectItem({ route: "/", id: `${baseId}.0` }),
  };

  return [home, ...subItems];
};
